import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'
import type { CSSProperties } from 'react'

const popupBodyStyle: CSSProperties = {
  marginBottom: '16px',
  marginTop: '5px'
}

const WebhookRequestMethodDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Request method
    </Header>
    <div style={popupBodyStyle}>
      <Paragraph>
        <Color variant='greyB'>
          Select from the available webhook request methods: POST, PUT, GET. (Default: POST)
        </Color>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </>

export default WebhookRequestMethodDescription
